<template>
  <div>
    <div class="text-right my-3">
      <router-link :to="{name:'adminMainWrite'}" class="btn btn-outline-secondary">배너 추가</router-link>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">제목</th>
          <th scope="col" class="text-center">순서</th>
          <th scope="col" class="text-center" style="width: 70px;">공개</th>
          <th scope="col" style="width: 100px;" class="text-center">작성일</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="list.length === 0">
          <td colspan="5" class="text-center" style="height: 300px;">데이터가 없습니다.</td>
        </tr>
        <tr v-for="(item, idx) in list" :key="idx">
          <th scope="row">{{item.id}}</th>
          <td>
            <router-link :to="{name: 'adminMainView', params: { id: item.id }}">{{item.title | normalize}}</router-link>
          </td>
          <td class="text-center">{{item.orderNo}}</td>
          <td class="text-center">{{item.status ? '공개' : '비공개'}}</td>
          <td class="text-center"><small>{{item.createAt | moment('YYYY-MM-DD HH:mm:ss')}}</small></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AdminMainList',
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    console.log('newsList');
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get('/admin/main')
        .then(({ data }) => {
          this.list = data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>

</style>
